/** @jsx jsx */

/** @jsxFrag React.Fragment */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import SideNavExpandableItem from 'bundles/enterprise-admin-navigation/components/side-nav/base/SideNavExpandableItem';
import SideNavItem from 'bundles/enterprise-admin-navigation/components/side-nav/base/SideNavItem';
import type { SideNavItem as SideNavItemType } from 'bundles/enterprise-admin-navigation/components/side-nav/base/types';

const styles = {
  list: css`
    list-style: none;
    padding: var(--cds-spacing-200) var(--cds-spacing-200) 0;
    margin: 0;
    display: flex;
    flex-direction: column;
    gap: var(--cds-spacing-50);
  `,
};

type Props = {
  items: SideNavItemType[];
};

/**
 *
 * The SideNavList component is used to render the list of items in the sidebar.
 * @param items - The items to render in the list
 * @returns The SideNavList component
 */
export const SideNavList = ({ items }: Props) => {
  return (
    <ul css={styles.list}>
      {items.map((item) => {
        if (item.children && item.children.length > 0) {
          return <SideNavExpandableItem key={item.id} item={item} />;
        }
        return <SideNavItem key={item.id} item={item} />;
      })}
    </ul>
  );
};

export default SideNavList;
